// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2PEHB","label":"Completed_label__-0tWf"};